<template>
  <div class="club-item">
    <div class="img-container">
      <img width="300px" height="205px" class="club-image" :src="require(`@/assets/clubs/${img}.png`)" />
    </div>
    <div class="club-header">{{ name }}</div>
    <div class="club-header info">View Info...</div>
    <p class="club-desc">{{desc}}</p>
  </div>
</template>

<script>
export default {
  name: 'clubItem',
  props: {
    name: String,
    img: String,
    desc: String
  },
}
</script>